import { LoadingSkeleton } from "../components/LoadingSkeleton";
import { useEffect, useState } from "react";
import { request } from "../api/client";
import { ErrorNotice } from "../components/AdminFeedback";
import { useLocale } from "../i18n";
import { OrganizationEditor } from "./OrganizationEditor";
import type { OrganizationDetails } from "./organizationTypes";

export function OrganizationEditScreen({ id, onClose, onSaved }: {
  id: string; onClose: () => void; onSaved: () => void;
}) {
  const { w } = useLocale();
  const [organization, setOrganization] = useState<OrganizationDetails>();
  const [error, setError] = useState<unknown>();
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setOrganization(undefined); setError(undefined);
    void request<OrganizationDetails>("/organizationManagement/detail?" + new URLSearchParams({ partyId: id }), "GET", undefined, controller.signal)
      .then(value => { if (!controller.signal.aborted) setOrganization(value); })
      .catch(value => { if (!controller.signal.aborted) setError(value); });
    return () => controller.abort();
  }, [id, revision]);
  if (organization) return <OrganizationEditor key={revision} organization={organization} onClose={onClose} onSaved={onSaved} onReload={() => setRevision(value => value + 1)} />;
  return <section className="organization-workspace"><h2>{w("تعديل منشأة", "Edit organization")}</h2>
    <ErrorNotice error={error} operation="read" retry={() => setRevision(value => value + 1)} />
    {!error && <LoadingSkeleton variant="form" label={w("جارٍ تحميل بيانات المنشأة…", "Loading organization details…")} />}
    <button className="secondary" onClick={onClose}>{w("العودة إلى المنشآت", "Back to organizations")}</button>
  </section>;
}
